module.exports = "/static/fonts/OpenSans-ExtraBoldItalic.woff";